module.exports = __webpack_public_path__ + "img/donauwoerth_2015_ref.dfb93660.jpg";